import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.PhotoMode}-enter {
		.${Layouts.PhotoMode}-background {
			opacity: 0;
		}

		.${Layouts.PhotoMode} {
			opacity: 0;
		}
	}

	&.${Layouts.PhotoMode}-enter-active,
		&.${Layouts.PhotoMode}-enter-done,
		&.${Layouts.PhotoMode}-exit {
		.${Layouts.PhotoMode}-background {
			opacity: 1;
		}

		.${Layouts.PhotoMode} {
			opacity: 1;
		}
	}

	&.${Layouts.PhotoMode}-exit-active {
		.${Layouts.PhotoMode}-background {
			opacity: 0;
		}

		.${Layouts.PhotoMode} {
			opacity: 0;
		}
	}
`;
